// network_slice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  wasOffline: false,
  pendingSyncCount: 0,
  isInitialized: false
};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setOnlineStatus: (state, action) => {
      const newOnline = action.payload;
      state.wasOffline = state.isInitialized && !state.isOnline && newOnline;
      state.isOnline = newOnline;
      state.isInitialized = true;
    },
    incrementPendingSync: (state) => {
      state.pendingSyncCount += 1;
    },
    decrementPendingSync: (state) => {
      state.pendingSyncCount = Math.max(0, state.pendingSyncCount - 1);
    },
    resetPendingSync: (state) => {
      state.pendingSyncCount = 0;
    }
  }
});

export const { setOnlineStatus, incrementPendingSync, decrementPendingSync, resetPendingSync } = networkSlice.actions;
export default networkSlice.reducer;